import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { TokenService } from '../services/token.service';

/**
 * Reads the Bearer token that authHttpInterceptorFn (Auth0) already attached
 * to the outgoing request and stores it in TokenService so it can be
 * read synchronously by JsonSchemaToSurveyService when setting up
 * choicesByUrl auth headers for external-source form fields.
 *
 * Must be registered AFTER authHttpInterceptorFn in the interceptor chain.
 */
export const tokenCacheInterceptor: HttpInterceptorFn = (req, next) => {
  const tokenService = inject(TokenService);
  const auth = req.headers.get('Authorization');
  if (auth?.startsWith('Bearer ')) {
    tokenService.set(auth.slice(7));
  }
  return next(req);
};
